// Anonymized mock initiatives data (Growth / Interventions / Functional)
export const GROWTH_MOCK = {
  row_header: [
    { key: 'project_objective', label: 'Project Objective' },
    { key: 'project_id', label: 'Project ID' },
    { key: 'project_description', label: 'Project Description' },
    { key: 'account_owner', label: 'Account Owner' },
    { key: 'account_owner_title', label: 'Title' },
    { key: 'report_to', label: 'Report To' },
    { key: 'report_to_title', label: 'Title' },
  ],
  row_data: [
    {
      project_objective: 'Volume Mix',
      project_id: 'G1-FY27',
      project_description: 'Improve focus-market coverage and monthly volume contribution',
      account_owner: '',
      account_owner_title: 'Chief of Sales',
      report_to: '',
      report_to_title: 'President',
      clickable: true,
    },
    {
      project_objective: 'Blended Mix',
      project_id: 'G2-FY27',
      project_description: 'Lift blended product share across priority zones',
      account_owner: '',
      account_owner_title: 'Regional Head',
      report_to: '',
      report_to_title: 'VP Sales',
      clickable: false,
    },
    {
      project_objective: 'Premium Mix',
      project_id: 'G3-FY27',
      project_description: 'Increase premium contribution in selected districts',
      account_owner: '',
      account_owner_title: 'Area Head',
      report_to: '',
      report_to_title: 'National Head',
      clickable: false,
    },
    {
      project_objective: 'Volume Mix',
      project_id: 'G4-FY27',
      project_description: 'Reactivate dormant accounts in focus markets',
      account_owner: '',
      account_owner_title: 'State Head',
      report_to: '',
      report_to_title: 'President',
      clickable: false,
    },
    {
      project_objective: 'Blended Mix',
      project_id: 'G5-FY27',
      project_description: 'Expand coverage in under-penetrated areas',
      account_owner: '',
      account_owner_title: 'Chief of Sales',
      report_to: '',
      report_to_title: 'VP Sales',
      clickable: false,
    },
    {
      project_objective: 'Premium Mix',
      project_id: 'G6-FY27',
      project_description: 'Drive premium SKU adoption with targeted actions',
      account_owner: '',
      account_owner_title: 'Regional Head',
      report_to: '',
      report_to_title: 'National Head',
      clickable: false,
    },
  ],
};

export const INTERVENTIONS_MOCK = {
  row_header: [
    { key: 'project_objective', label: 'Project Objective' },
    { key: 'project_id', label: 'Project ID' },
    { key: 'project_description', label: 'Project Description' },
    { key: 'user_name', label: 'User Name' },
    { key: 'report_to', label: 'Report To' },
  ],
  row_data: [
    {
      project_objective: 'Recover Volume Shortfall',
      project_id: 'I1-FY27',
      project_description: 'Close monthly volume gap in priority markets',
      user_name: '',
      report_to: '',
      created_on: '',
      enabling_one_description: '',
      enabling_two_description: '',
      clickable: true,
    },
    {
      project_objective: 'Zero-Sales Accounts',
      project_id: 'I2-FY27',
      project_description: 'Address accounts with no recorded sales activity',
      user_name: '',
      report_to: '',
      created_on: '',
      enabling_one_description: '',
      enabling_two_description: '',
      clickable: false,
    },
  ],
};

export const FUNCTIONAL_KANBAN_MOCK = [
  {
    key: 'L1',
    label: 'Ideation',
    cards: [
      {
        id: 'INIT-000125',
        priority: 'Medium',
        title: 'Digitize credit-note workflow',
        owner: '',
        reportsTo: '',
        target: '05-Sep-2026',
        status: 'On Track',
        pending: false,
      },
      {
        id: 'INIT-000126',
        priority: 'Medium',
        title: 'Expand premium mix in secondary towns',
        owner: '',
        reportsTo: '',
        target: '15-Sep-2026',
        status: 'Pending Approval',
        pending: true,
      },
      {
        id: 'INIT-000127',
        priority: 'High',
        title: 'Automate compliance alert checks',
        owner: '',
        reportsTo: '',
        target: '10-Sep-2026',
        status: 'Pending Approval',
        pending: true,
      },
      {
        id: 'INIT-000130',
        priority: 'Low',
        title: 'Clean up district hierarchy master',
        owner: '',
        reportsTo: '',
        target: '25-Aug-2026',
        status: 'Pending Approval',
        pending: true,
      },
    ],
  },
  {
    key: 'L2',
    label: 'Feasible',
    cards: [
      {
        id: 'INIT-000123',
        priority: 'High',
        title: 'Improve partner activation rate',
        owner: '',
        reportsTo: '',
        target: '25-Aug-2026',
        status: 'At Risk',
        pending: false,
      },
    ],
  },
  {
    key: 'L3',
    label: 'Under Execution',
    cards: [
      {
        id: 'INIT-000124',
        priority: 'High',
        title: 'Reduce churn in focus zone',
        owner: '',
        reportsTo: '',
        target: '15-Aug-2026',
        status: 'Delayed 5d',
        pending: false,
      },
    ],
  },
  {
    key: 'L4',
    label: 'Achieved',
    cards: [
      {
        id: 'INIT-000128',
        priority: 'Medium',
        title: 'Partner onboarding turnaround',
        owner: '',
        reportsTo: '',
        target: '22-Aug-2026',
        status: 'At Risk',
        pending: false,
      },
    ],
  },
  {
    key: 'L5',
    label: 'Closed',
    cards: [
      {
        id: 'INIT-000129',
        priority: 'Low',
        title: 'Outlet branding refresh program',
        owner: '',
        reportsTo: '',
        target: '10-Aug-2026',
        status: '5 Days Ahead',
        pending: false,
      },
    ],
  },
];
